<small *ngIf="user && !user.phone?.phone_number">
  <ag-cellphone-verification
  #cellVerification></ag-cellphone-verification>
  <span [innerHtml]="'ADD_PHONE.MESSAGE'|translate"></span>&nbsp;
  <a (click)="cellVerification.addPhone()"
  [innerText]="'CELLPHONE_VERIFICATION.ADD'|translate"></a>
</small>